import {
  Box,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Text,
} from "@chakra-ui/react";
import { useStytch } from "@stytch/react";
import {
  AuthFactorInstanceProps,
  TotpAuthFactorInstance,
} from "features/auth/AuthFactor";
import { AuthHelpButton } from "features/auth/AuthHelpButton";
import { AuthOtpFormData } from "features/auth/AuthTypes";
import {
  getStytchSessionDurationMinutes,
  useStytchFormErrorHandler,
} from "features/auth/StytchUtils";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import { CardCloseButton } from "shared/components/card/CardCloseButton";
import Form from "shared/components/form/Form";
import { FormNumberInput } from "shared/components/input/text/NumberInput";

export const AuthFactorTotp: React.FC<
  AuthFactorInstanceProps<TotpAuthFactorInstance>
> = ({ onCancel, onSuccess, onSelectAuthFactor, rememberDevice }) => {
  const { t } = useTranslation(["common", "auth"]);
  const stytchClient = useStytch();
  const onStytchError = useStytchFormErrorHandler();

  const form = useForm<AuthOtpFormData>();

  const onSubmit = async (data: AuthOtpFormData) =>
    stytchClient.totps.authenticate({
      totp_code: data.code,
      session_duration_minutes: getStytchSessionDurationMinutes(rememberDevice),
    });

  return (
    <Form
      form={form}
      disableNavBlocker={true}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      onError={onStytchError}
    >
      <Card width="md">
        <CardHeader>
          <Box>
            <Text textStyle="h4">{t("auth:authenticate")}</Text>
            <Text pt="24px">{t("auth:totpInstructions")}</Text>
          </Box>
          <CardCloseButton onClick={onCancel} />
        </CardHeader>
        <CardBody pb="4px">
          <FormNumberInput
            name="code"
            title={t("auth:code")}
            autoFocus={true}
            maxLength={6}
            allowLeadingZeros={true}
            thousandSeparator={false}
            hideIcon={true}
          />
        </CardBody>
        <CardFooter>
          <AuthHelpButton
            onClick={() => {
              onSelectAuthFactor({
                id: "recovery",
                type: "recovery",
                data: {},
              });
            }}
          >
            {t("auth:useRecoveryCode")}
          </AuthHelpButton>
          <FormSubmitButton>{t("common:continue")}</FormSubmitButton>
        </CardFooter>
      </Card>
    </Form>
  );
};
